import { render, staticRenderFns } from "./ModalChooseNameAndDescription.vue?vue&type=template&id=7e569d82"
import script from "./ModalChooseNameAndDescription.vue?vue&type=script&lang=js"
export * from "./ModalChooseNameAndDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports